/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@mui/material'

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import clsx from 'clsx'
import ReactPlayer from 'react-player'
import moment from 'moment'
import { withStyles } from '~/themes/useStyles'
import { bytesToSize, isFileImage } from '~/utils/helpers/media'
import style from './style'
import Checkbox from '~/components/common/Checkbox'
import { TextBlockToolTip } from '~/components/common/TextBlock'

const listHead = [
  {
    id: 'checkbox',
    title: '',
    sort: false,
    style: {
      minWidth: 50,
    },
  },
  {
    id: 'image',
    title: 'Image',
    sort: false,
    style: {
      minWidth: 80,
    },
  },
  {
    id: 'title',
    title: 'Name',
    sort: true,
    style: {
      minWidth: 400,
      paddingRight: 20,
      width: '100%',
    },
  },
  {
    id: 'file_type',
    title: 'File Type',
    sort: true,
    style: {
      minWidth: 150,
    },
  },
  {
    id: 'size',
    title: 'File Size',
    sort: true,
    style: {
      minWidth: 150,
    },
  },
  {
    id: '_created',
    title: 'Creation Date',
    sort: true,
    style: {
      minWidth: 150,
      justifyContent: 'flex-end',
    },
  },
]

const ListView = ({
  classes,
  files,
  selectVideo,
  selectImage,
  fileSelected,
  loading,
  mediaFile,
  isFileSelected,
  handleSelectFile,
  handleOpenFile,
  sortBy = {},
  onSort,
  bulkSelect,
}) => {
  const getCheckboxDisableState = (file) => {
    if (isFileImage(file)) {
      return !selectImage
    }
    return !selectVideo
  }

  const handleOnClickCheckbox = (file, index) => {
    if (isFileImage(file)) {
      return selectImage && handleSelectFile(file, index)
    }
    return selectVideo && handleSelectFile(file, index)
  }

  useEffect(() => {
    const container = document.getElementById('containerAllFiles')
    // eslint-disable-next-line no-unused-expressions
    container.scrollTo({ top: 0, left: 0 })
  }, [files])

  const renderHead = () => (
    <div className={classes.headContainer}>
      {listHead
        .filter((item) => (!fileSelected ? item.id !== 'checkbox' : item))
        .map((item) => (
          <div
            className={clsx(classes.headItem, item.sort && 'isSorting')}
            key={item.id}
            style={item.style}
            role="presentation"
            onClick={() => {
              if (!item.sort) return
              let desc = 0
              if (!sortBy[item.id]) {
                desc = -1
              } else if (sortBy[item.id] === -1) {
                desc = 1
              }
              onSort(item.id, desc)
            }}
          >
            {item.title}
            {item.sort ? (
              <div>
                {!sortBy[item.id] ? (
                  <span className={classes.sortableIcon} />
                ) : (
                  <ArrowDropDownIcon
                    className={clsx(classes.sortIcon, {
                      [classes.sortIconDesc]: sortBy[item.id] === 1,
                    })}
                  />
                )}
              </div>
            ) : (
              ''
            )}
          </div>
        ))}
    </div>
  )

  const renderList = () => (
    <div id="mediaFileContainer" className={classes.listContainer}>
      {files.map((file, index) => (
        <div
          key={file.id}
          data-name={
            file.title ||
            file.name.replace(/.jpg|.png|.jpeg|.mp4|.quicktime/, '')
          }
          data-id={file.id}
          draggable="true"
          role="presentation"
          onClick={() => handleSelectFile(file, index)}
          onDoubleClick={() => handleOpenFile(index)}
        >
          <div
            className={clsx(
              classes.itemContainer,
              index % 2 && 'bgBlue',
              'listViewItem',
              isFileSelected(file) && 'selected',
            )}
          >
            {fileSelected && bulkSelect ? (
              <div style={listHead[0].style}>
                <Checkbox
                  className={classes.selectedButton}
                  disabled={getCheckboxDisableState(file)}
                  checked={isFileSelected(file)}
                  onClick={(event) => {
                    event.stopPropagation()
                    handleOnClickCheckbox(file, index)
                  }}
                  classes={{
                    checkedIcon: classes.checkedIcon,
                    uncheckedIcon: classes.uncheckedIcon,
                  }}
                />
              </div>
            ) : (
              ''
            )}
            <div
              style={{
                ...listHead[1].style,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {isFileImage(file) ? (
                <img
                  className={classes.image}
                  width={60}
                  height={60}
                  src={file.thumbnail}
                  alt={file.name}
                />
              ) : (
                <div className={classes.videoContainer}>
                  <img
                    className={classes.videoImage}
                    alt="play-video"
                    src="/img/play-video.svg"
                  />
                  <ReactPlayer
                    className={classes.video}
                    url={file.src}
                    light={file.thumbnail}
                    playing={false}
                  />
                </div>
              )}
            </div>
            <div
              style={{
                ...listHead[2].style,
              }}
            >
              {file.title && (
                <TextBlockToolTip title={<span>{file.title || ''}</span>}>
                  <div data-tooltip className={classes.fileName}>
                    {file.title || ''}
                  </div>
                </TextBlockToolTip>
              )}

              <TextBlockToolTip title={<span>{file.name}</span>}>
                <div data-tooltip className={clsx(classes.fileDesc)}>
                  {file.name}
                </div>
              </TextBlockToolTip>
            </div>
            <div style={listHead[3].style}>{file.file_type}</div>
            <div style={listHead[4].style}>{bytesToSize(file.size)}</div>
            <div
              style={{
                ...listHead[5].style,
                textAlign: 'right',
              }}
            >
              {moment(file._created).format('MM/DD/YYYY')}
            </div>
          </div>
        </div>
      ))}
      {loading.getListFile &&
      mediaFile.total_pages &&
      mediaFile.page <= mediaFile.total_pages ? (
        <div className={classes.containerLoadMore}>
          <CircularProgress size={14} />
        </div>
      ) : (
        ''
      )}
    </div>
  )

  return (
    <div className={classes.container} id="containerAllFiles">
      {renderHead()}
      {renderList()}
    </div>
  )
}

ListView.defaultProps = {
  files: [],
  onSort: () => {},
  fileSelected: null,
  bulkSelect: false,
}

ListView.propTypes = {
  classes: PropTypes.shape().isRequired,
  onSort: PropTypes.func,
  sortBy: PropTypes.oneOfType([PropTypes.object, PropTypes.shape()]).isRequired,
  loading: PropTypes.oneOfType([PropTypes.object, PropTypes.shape()])
    .isRequired,
  files: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
  mediaFile: PropTypes.oneOfType([PropTypes.object, PropTypes.shape()])
    .isRequired,
  fileSelected: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
  isFileSelected: PropTypes.oneOfType([PropTypes.func, PropTypes.shape()])
    .isRequired,

  selectVideo: PropTypes.bool.isRequired,
  selectImage: PropTypes.bool.isRequired,
  handleSelectFile: PropTypes.func.isRequired,
  handleOpenFile: PropTypes.func.isRequired,
  bulkSelect: PropTypes.bool,
}

export default withStyles(style)(ListView)
